import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MedineerLogin from "../Components/MedineerComponents/MedineerLogin";
import "./TestDetailsPage.css";


const HeroTestDetailsPage = ({
    subscription,
    isLoggedIn,
    hideTestDetails,
    showSignUpForm,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();

    const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);

    const series = {
        courseId: subscription?.subscriptionTypeId ?? subscription?.courseId,
        price: price ?? 0,
    };

    const onNextHandle = () => {
        const ResourceTypeId = 4;
        if (isLoggedIn) {
            setShowCheckout(true);
        } else {
            // showSignUpForm?.();
            navigate("/medineer/SignUp", { state: { series, ResourceTypeId } });
        }
    };

    const handleCloseModal = () => {
        hideTestDetails?.();
        setShowCheckout(false);
    };

    return (
        <div className="testDetailsContainer">
            {/* IMAGE SECTION */}
            <div
                className="imageContainer"
                style={{ display: isMobile ? "none" : "flex" }}
            >
                <img src={"/CreateTests.png"} alt="Students discussing tests" />
            </div>

            {/* TEXT SECTION */}
            <div className="textContainer">
                <div className="subHeader">
                    {isMobile ? (
                        <h2>Monthly Test Pack</h2>
                    ) : (
                        <h3>Topic Pulse - Monthly TopicWise Tests</h3>
                    )}
                </div>

                <hr style={{ height: "4px", background: "#f8cb1e", margin: "10px 0" }} />

                <ul className={isMobile ? "detailsPointsMobile" : "detailsPoints"}>
                    <li>
                        Build your <b>own plan</b>—pick the <b>right test immediately</b>{" "}
                        after mastering a topic.
                    </li>
                    <li>
                        Get instant <b>performance reviews</b> with detailed{" "}
                        <b>solutions</b> and clear insights for every question.
                    </li>
                    <li>
                        Understand where to improve with clear, <b>topic-based analytics</b>{" "}
                        and easy-to-read visual graphs.
                    </li>
                    <li>
                        <b>Start</b> today—build <b>confidence</b> with focused{" "}
                        <b>practice</b> and stay ahead of the competition.
                    </li>
                    <li>
                        Take charge of your <b>success journey</b> with on-demand tests
                        aligned to your preparation.
                    </li>
                </ul>

                <div className="buttonContainer">
                    <button className="signUpButton" onClick={onNextHandle}>
                        {isLoggedIn ? "Next" : "Sign Up"}
                    </button>
                </div>

                {showCheckout && (
                    <MedineerLogin
                        course={series}
                        ResourceTypeId={4}
                        closeModal={handleCloseModal}
                    />
                )}
            </div>
        </div>
    );
};

export default HeroTestDetailsPage;
